/* FurXit™ – Theme JS (schlank, ohne Abhängigkeiten) */
(function () {
  'use strict';
  document.documentElement.classList.remove('no-js');
  var FX = window.FX || {};
  var routes = FX.routes || { cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cart: '/cart.js', cartUrl: '/cart' };
  var money = function (cents) {
    try { return new Intl.NumberFormat('de-DE', { style: 'currency', currency: FX.currency || 'EUR' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  };
  FX.money = money;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); };

  /* Header beim Scrollen kompakter */
  var header = $('.fx-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 12); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* Panels (Menü, Warenkorb) */
  var lastFocus = null;
  function openPanel(panel) {
    lastFocus = document.activeElement;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var f = panel.querySelector('[data-autofocus]') || panel.querySelector('button, a, input');
    if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function closePanel(panel) {
    if (!panel) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') $$('.fx-menu.is-open, .fx-drawer.is-open').forEach(closePanel);
  });

  /* Mobile Menü */
  var menu = $('#fx-menu');
  $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { if (menu) { openPanel(menu); b.setAttribute('aria-expanded', 'true'); } }); });
  $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { closePanel(menu); $$('[data-menu-open]').forEach(function (x) { x.setAttribute('aria-expanded', 'false'); }); }); });
  if (menu) $$('a', menu).forEach(function (a) { a.addEventListener('click', function () { closePanel(menu); }); });

  /* Fade-In */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    $$('[data-fade]').forEach(function (el) { io.observe(el); });
  } else { $$('[data-fade]').forEach(function (el) { el.classList.add('is-in'); }); }

  /* Warenkorb (Drawer) */
  var drawer = $('#fx-drawer');
  var countEls = $$('[data-cart-count]');
  function setCount(n) { countEls.forEach(function (el) { el.textContent = n; el.hidden = n < 1; }); }
  function fetchJSON(url, opts) {
    return fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, opts || {}))
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  var I = { minus: '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M3 8h10"/></svg>', plus: '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M3 8h10M8 3v10"/></svg>' };
  var QTY_RE = /menge|anzahl|stück|stueck|set|quantity|pack/i;

  function findUpgrade(cart) {
    var p = FX.product; if (!p || !p.variants) return null;
    var qi = -1; p.options.forEach(function (n, i) { if (QTY_RE.test(n)) qi = i; });
    if (qi < 0) return null;
    var lines = cart.items.filter(function (it) { return it.product_id === p.id; });
    if (lines.length !== 1 || lines[0].quantity !== 1) return null;
    var cur = null; p.variants.forEach(function (v) { if (v.id === lines[0].variant_id) cur = v; });
    if (!cur || !/^1\b/.test(cur.options[qi])) return null;
    var target = null;
    p.variants.forEach(function (v) {
      if (!v.available || !/^2\b/.test(v.options[qi])) return;
      var same = v.options.every(function (o, i) { return i === qi || o === cur.options[i]; });
      if (same) target = v;
    });
    if (!target) return null;
    return { key: lines[0].key, id: target.id, save: cur.price * 2 - target.price };
  }

  function renderCart(cart) {
    setCount(cart.item_count);
    if (!drawer) return;
    var body = $('[data-drawer-body]', drawer);
    var foot = $('[data-drawer-foot]', drawer);
    if (!cart.item_count) {
      body.innerHTML = '<div class="fx-drawer__empty"><p class="fx-h3" style="color:var(--fx-ink)">Dein Warenkorb ist leer.</p><p>Bereit für weniger Tierhaare?</p><a class="fx-btn" href="' + esc(FX.productUrl || '/collections/all') + '">FurXit™ entdecken</a></div>';
      foot.hidden = true; return;
    }
    foot.hidden = false;
    var html = '';
    var up = findUpgrade(cart);
    if (up && up.save > 0) {
      html += '<div class="fx-upgrade"><p><strong>Zweiter FurXit™ fürs Auto?</strong>Im 2er-Set sparst du ' + money(up.save) + '.</p><button type="button" data-upgrade="' + up.id + '" data-key="' + esc(up.key) + '">Zum 2er-Set</button></div>';
    }
    cart.items.forEach(function (it) {
      var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
      var variant = (it.variant_title && it.variant_title !== 'Default Title') ? esc(it.variant_title).replace(/\s*\/\s*/g, ' · ') : '';
      html += '<div class="fx-line">' +
        (img ? '<img class="fx-line__img" src="' + esc(img) + '" alt="" width="84" height="84" loading="lazy">' : '<div class="fx-line__img"></div>') +
        '<div><a class="fx-line__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
        (variant ? '<p class="fx-line__variant">' + variant + '</p>' : '') +
        '<div class="fx-qty" role="group" aria-label="Menge"><button type="button" data-qty="' + (it.quantity - 1) + '" data-key="' + esc(it.key) + '" aria-label="Menge verringern">' + I.minus + '</button><span>' + it.quantity + '</span><button type="button" data-qty="' + (it.quantity + 1) + '" data-key="' + esc(it.key) + '" aria-label="Menge erhöhen">' + I.plus + '</button></div>' +
        '<div><button type="button" class="fx-line__remove" data-qty="0" data-key="' + esc(it.key) + '">Entfernen</button></div></div>' +
        '<div class="fx-line__price">' + money(it.final_line_price) + (it.original_line_price > it.final_line_price ? '<br><s class="fx-muted" style="font-weight:400;font-size:.85rem">' + money(it.original_line_price) + '</s>' : '') + '</div>' +
        '</div>';
    });
    body.innerHTML = html;
    $('[data-drawer-subtotal]', drawer).textContent = money(cart.total_price);
  }

  function refreshCart() { return fetchJSON(routes.cart).then(renderCart); }
  function openDrawer() { if (!drawer) { window.location.href = routes.cartUrl; return; } refreshCart(); openPanel(drawer); }
  function busy(on) { if (drawer) drawer.classList.toggle('is-loading', on); }

  if (drawer) {
    $$('[data-drawer-open]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); }); });
    $$('[data-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', function () { closePanel(drawer); }); });
    drawer.addEventListener('click', function (e) {
      var q = e.target.closest('[data-qty]');
      if (q) {
        busy(true);
        fetchJSON(routes.cartChange, { method: 'POST', body: JSON.stringify({ id: q.dataset.key, quantity: parseInt(q.dataset.qty, 10) }) })
          .then(renderCart).catch(refreshCart).then(function () { busy(false); });
        return;
      }
      var u = e.target.closest('[data-upgrade]');
      if (u) {
        busy(true);
        fetchJSON(routes.cartChange, { method: 'POST', body: JSON.stringify({ id: u.dataset.key, quantity: 0 }) })
          .then(function () { return fetchJSON(routes.cartAdd, { method: 'POST', body: JSON.stringify({ items: [{ id: parseInt(u.dataset.upgrade, 10), quantity: 1 }] }) }); })
          .then(refreshCart).catch(refreshCart).then(function () { busy(false); });
      }
    });
  }

  /* Produktformular */
  $$('form[data-fx-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!drawer || !window.fetch) return;
      e.preventDefault();
      var btns = $$('[data-atc], [data-sticky-btn]');
      var err = $('[data-atc-error]', form);
      btns.forEach(function (b) { b.disabled = true; b.dataset.label = b.innerHTML; b.textContent = 'Wird hinzugefügt …'; });
      fetch(routes.cartAdd, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { if (err) err.hidden = true; openDrawer(); })
        .catch(function (j) { if (err) { err.textContent = (j && (j.description || j.message)) || 'Das hat leider nicht geklappt. Bitte versuche es erneut.'; err.hidden = false; } })
        .then(function () { btns.forEach(function (b) { b.disabled = false; b.innerHTML = b.dataset.label; }); if (FX.syncAtc) FX.syncAtc(); });
    });
  });

  /* Produktseite */
  var pdp = $('[data-fx-pdp]');
  if (pdp) {
    var data = JSON.parse(($('#fx-product-json') || {}).textContent || '{"options":[],"variants":[]}');
    var form = $('form[data-fx-product-form]', pdp);
    var idInput = $('input[name="id"]', form);
    var qi = -1; (data.options || []).forEach(function (n, i) { if (QTY_RE.test(n)) qi = i; });
    var findV = function (sel) { var m = null; data.variants.forEach(function (v) { if (v.options.every(function (o, i) { return o === sel[i]; })) m = v; }); return m; };
    var selected = function () { return (data.options || []).map(function (n, i) { var c = $('input[data-opt-index="' + i + '"]:checked', pdp); return c ? c.value : null; }); };
    var unitPriceFor = function (v) {
      var single = null;
      data.variants.forEach(function (x) { if (/^1\b/.test(x.options[qi]) && x.options.every(function (o, i) { return i === qi || o === v.options[i]; })) single = x; });
      return single ? single.price : null;
    };
    var updateBundles = function () {
      if (qi < 0) return;
      $$('input[data-opt-index="' + qi + '"]', pdp).forEach(function (inp) {
        var sel = selected(); sel[qi] = inp.value;
        var v = findV(sel); var lab = inp.nextElementSibling; if (!lab || !v) return;
        var n = parseInt(inp.value, 10) || 1;
        var unit = unitPriceFor(v);
        var regular = unit && n > 1 ? unit * n : 0;
        var priceEl = $('[data-b-price]', lab), wasEl = $('[data-b-was]', lab), saveEl = $('[data-b-save]', lab), perEl = $('[data-b-per]', lab);
        if (priceEl) priceEl.textContent = money(v.price);
        if (wasEl) { wasEl.textContent = regular > v.price ? 'einzeln ' + money(regular) : ''; wasEl.hidden = !(regular > v.price); }
        if (saveEl) { saveEl.textContent = regular > v.price ? 'Du sparst ' + money(regular - v.price) : ''; saveEl.hidden = !(regular > v.price); }
        if (perEl) { perEl.textContent = n > 1 ? money(Math.round(v.price / n)) + ' pro Stück' : ''; perEl.hidden = !(n > 1); }
        inp.disabled = !v.available;
      });
    };
    var syncAtc = function () {
      var v = findV(selected());
      var atcs = $$('[data-atc]');
      var sb = $('[data-sticky-btn]');
      if (!v) { atcs.forEach(function (b) { b.disabled = true; b.textContent = 'Nicht verfügbar'; }); if (sb) sb.disabled = true; return; }
      idInput.value = v.id;
      $$('[data-price-now]').forEach(function (el) { el.textContent = money(v.price); });
      var was = $('[data-price-was]', pdp);
      if (was) { var show = v.compare_at_price && v.compare_at_price > v.price; was.textContent = show ? money(v.compare_at_price) : ''; was.hidden = !show; }
      atcs.forEach(function (b) { b.disabled = !v.available; b.textContent = v.available ? 'In den Warenkorb – ' + money(v.price) : 'Derzeit ausverkauft'; });
      if (sb) sb.disabled = !v.available;
      $$('[data-sticky-meta]').forEach(function (el) { el.textContent = v.title.replace(/\s*\/\s*/g, ' · '); });
      $$('[data-opt-label]', pdp).forEach(function (el) { el.textContent = v.options[+el.dataset.optLabel]; });
      try { var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url.toString()); } catch (e) {}
      if (v.featured_media && FX.galleryTo) FX.galleryTo(v.featured_media);
    };
    FX.syncAtc = syncAtc;

    /* Galerie */
    var track = $('[data-gallery-track]', pdp);
    if (track) {
      var slides = $$('[data-media-id]', track);
      var navs = $$('[data-gallery-go]', pdp);
      var setActive = function (i) { navs.forEach(function (n) { n.setAttribute('aria-current', +n.dataset.galleryGo === i ? 'true' : 'false'); }); };
      var goTo = function (i) { var s = slides[i]; if (!s) return; track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' }); setActive(i); };
      navs.forEach(function (n) { n.addEventListener('click', function () { goTo(+n.dataset.galleryGo); }); });
      var t; track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { setActive(Math.round(track.scrollLeft / track.clientWidth)); }, 60); }, { passive: true });
      FX.galleryTo = function (mediaId) { slides.forEach(function (s, i) { if (+s.dataset.mediaId === +mediaId) goTo(i); }); };
      setActive(0);
    }

    $$('input[data-opt-index]', pdp).forEach(function (inp) { inp.addEventListener('change', function () { updateBundles(); syncAtc(); }); });
    updateBundles(); syncAtc();

    /* Sticky Add-to-Cart */
    var sticky = $('[data-sticky]');
    var mainAtc = $('[data-atc-main]', pdp);
    if (sticky && mainAtc && 'IntersectionObserver' in window) {
      var footer = $('.fx-footer');
      var atcVisible = true, footVisible = false;
      var upd = function () {
        var on = !atcVisible && !footVisible && mainAtc.getBoundingClientRect().top < 0;
        sticky.classList.toggle('is-visible', on); document.body.classList.toggle('has-sticky', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        $$('a,button', sticky).forEach(function (el) { el.tabIndex = on ? 0 : -1; });
      };
      new IntersectionObserver(function (en) { atcVisible = en[0].isIntersecting; upd(); }).observe(mainAtc);
      if (footer) new IntersectionObserver(function (en) { footVisible = en[0].isIntersecting; upd(); }).observe(footer);
      upd();
      $('[data-sticky-btn]', sticky).addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else form.submit(); });
    }
  }

  if (countEls.length && window.fetch) fetchJSON(routes.cart).then(function (c) { setCount(c.item_count); }).catch(function () {});
  window.FX = FX;
})();
